<template>
  <div class="xxjj">
    <headerNav></headerNav>

    <div class="content">
      <div class="listLeft">
        <div class="leftTop">
          <img
            src="https://middle-school-p.oss-cn-beijing.aliyuncs.com/shouye/logo.png"
            alt=""
          />
          <div class="leftTitle">
            <div>服务保障</div>
          </div>
        </div>
        <ul class="listUl">
          <li
            v-for="(item, index) in twoList"
            :key="index"
            :class="[item.title == '学生餐饮' ? 'activeTitle' : 'normalTitle']"
            @click="toSkip(item.title)"
          >
            {{ item.title }}
          </li>
        </ul>
      </div>

      <div class="listRight">
        <div class="listRightHeader">
          <img
            src="https://middle-school-p.oss-cn-beijing.aliyuncs.com/shouye/back.png"
            alt=""
            @click="goBack"
            class="backImg"
          />
          <p class="headerTitle">学生餐饮</p>
        </div>
        <img
          src="https://middle-school-p.oss-cn-beijing.aliyuncs.com/shouye/xqLine.png"
          alt=""
          class="endLine"
        />
        <div class="titleAritcle">{{ rightData.title }}</div>
        <div class="zuozhe">
          <!-- <span> 作者:{{ rightData.author }}</span> -->
          <span>时间: {{ rightData.createTime }}</span>
          <!-- <span>点击量: {{ rightData.params.pvNum }}</span> -->
        </div>
        <div class="ql-snow fuwenben">
          <div class="ql-editor" v-html="rightData.richText"></div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import headerNav from "../../components/headerNav.vue";
import Footer from "../../components/footer.vue";
export default {
  name: "xxjj",
  components: { headerNav, Footer },
  data() {
    return {
      rightData: [],
      leftTitle: {},
      twoList: [],
      type: "",
    };
  },
  created() {},
  mounted() {
    var id = this.$route.query.id;
    console.log(id);
    this.api.navTwo({ id: 5 }).then((res) => {
      this.twoList = res.data;
      this.api.daibiao(id).then((res) => {
        console.log(res);
        this.rightData = res.data.data;
      });
    });
  },
  methods: {
    goBack() {
      this.$router.push("/canyin");
    },
    toSkip(e) {
      if (e == "学生住宿") {
        this.$router.push("/zhusu");
      } else if (e == "校车服务") {
        this.$router.push("/xiaoche");
      } else if (e == "学生校服") {
        this.$router.push("/xiaofu");
      }
    },
  },
};
</script>
<style scoped>
.xxjj {
  background: rgb(241, 241, 241);
}
.list {
}
li {
  list-style: none;
}
.content {
  min-width: 1200px;
  display: flex;
  justify-content: center;
  /* padding: 0 360px; */
  margin-top: 50px;
  margin-bottom: 85px;
}
.listLeft {
  width: 300px;
  background-color: white;
  box-shadow: 0px 5px 16px 0px rgba(37, 64, 107, 0.2);
  margin-right: 71px;
}
.leftTop {
  width: 270px;
  height: 75px;
  display: flex;
  padding: 20px 15px;
  justify-content: space-around;
  background: rgb(152, 33, 35);
}
.leftTop img {
  width: 80px;
  height: 80px;
  display: block;
}
.leftTitle div:nth-child(1) {
  color: rgb(255, 255, 255);
  font-family: 思源黑体;
  font-size: 28px;
  font-weight: 700;
  letter-spacing: 3px;
  text-align: left;
  margin-top: 10px;
}
.leftTitle div:nth-child(2) {
  color: rgb(255, 255, 255);
  font-family: 思源黑体;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 3px;
  text-align: left;
  margin-top: 10px;
}

.normalTitle {
  width: 100%;
  padding: 20px 0;
  text-align: center;
  border-bottom: 1px solid rgb(219, 218, 218);
  color: rgb(64, 64, 64);
  font-family: 思源黑体;
  font-size: 24px;
  font-weight: 400;
  letter-spacing: 3px;
  text-align: center;
  cursor: pointer;
}

.activeTitle {
  width: 100%;
  padding: 20px 0;
  color: rgb(191, 110, 18);
  font-family: 思源黑体;
  font-size: 24px;
  font-weight: 400;
  letter-spacing: 3px;
  text-align: center;
  background: rgb(255, 227, 227);
  cursor: pointer;
}

.listRight {
  width: 838px;
  padding: 0 20px;
  background: rgb(255, 255, 255);
}
.listRightHeader {
  color: rgb(152, 33, 35);
  font-family: 思源黑体;
  font-size: 28px;
  font-weight: 700;
  letter-spacing: 0%;
  text-align: left;
  margin: 20px 0;
}
.backImg {
  width: 30px;
  height: 30px;
}
.headerTitle {
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #992223;
  margin-left: 18px;
  margin-right: 7px;
  position: relative;
  top: -8px;
  display: inline-block;
}
.endLine {
  width: 838px;
  height: 12px;
}
.titleAritcle {
  color: rgb(64, 64, 64);
  font-family: 思源黑体;
  font-size: 28px;
  font-weight: 400;
  letter-spacing: 0px;
  text-align: center;
  margin-top: 40px;
  margin-bottom: 20px;
}

.newMian {
}
.newsItem {
  width: 100%;
  padding: 30px 0;
  display: flex;
  justify-content: space-around;
  border-bottom: 1px solid rgb(210, 210, 210);
  cursor: pointer;
}
.newsItem img {
  width: 154.11px;
  height: 120.97px;
}
.newsRight {
  width: 670px;
  margin-left: 15px;
}
.newsTitle {
  color: rgba(0, 0, 0, 0.8);
  font-family: 思源黑体;
  font-size: 18px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0px;
  text-align: left;
  margin-bottom: 10px;
}

.zuozhe {
  color: rgba(0, 0, 0, 0.3);
  font-family: 思源黑体;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0px;
  text-align: left;
  width: 80%;
  margin: 0 auto;
  margin-bottom: 30px;
  display: flex;
  justify-content: space-around;
}

.fuwenben {
  padding-bottom: 50px;
}

@media screen and (max-width: 1440px) {
  .leftTitle div:nth-child(2) {
    color: rgb(255, 255, 255);
    font-family: 思源黑体;
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 3px;
    text-align: left;
    margin-top: 0px;
  }
}

@media screen and (max-width: 450px) {
  .xxjj {
    background: rgb(241, 241, 241);
  }

  li {
    list-style: none;
  }
  .content {
    min-width: 350px;
    display: flex;
    justify-content: center;
    margin-top: 30px;
    margin-bottom: 85px;
  }
  .listLeft {
    width: 120px;
    background-color: white;
    box-shadow: 0px 2px 5px 0px rgba(37, 64, 107, 0.2);
    margin-right: 5px;
  }
  .leftTop {
    width: 110px;
    height: 55px;
    display: flex;
    padding: 5px;
    justify-content: space-around;
    background: rgb(152, 33, 35);
  }
  .leftTop img {
    width: 30px;
    height: 30px;
    display: block;
    margin-right: 0px;
  }
  .leftTitle div:nth-child(1) {
    color: rgb(255, 255, 255);
    font-family: 思源黑体;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 3px;
    text-align: left;
    margin-top: 5px;
  }
  .leftTitle div:nth-child(2) {
    color: rgb(255, 255, 255);
    font-family: 思源黑体;
    font-size: 5px;
    font-weight: 700;
    letter-spacing: 0px;
    text-align: left;
    margin-top: 0px;
  }
  .normalTitle {
    width: 100%;
    padding: 10px 0;
    text-align: center;
    border-bottom: 1px solid rgb(219, 218, 218);
    color: rgb(64, 64, 64);
    font-family: 思源黑体;
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 3px;
    text-align: center;
    cursor: pointer;
  }

  .activeTitle {
    width: 100%;
    padding: 10px 0;
    color: rgb(191, 110, 18);
    font-family: 思源黑体;
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 3px;
    text-align: center;
    background: rgb(255, 227, 227);
    cursor: pointer;
  }

  .listRight {
    width: 200px;
    padding: 0 10px;
    background: rgb(255, 255, 255);
  }
  .listRightHeader {
    color: rgb(152, 33, 35);
    font-family: 思源黑体;
    font-weight: 700;
    letter-spacing: 0%;
    text-align: left;
    margin: 10px 0;
  }

  .headerTitle {
    font-size: 15px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #992223;
    margin-left: 18px;
    margin-right: 7px;
  }
  .endLine {
    width: 200px;
    height: 5px;
  }
  .titleAritcle {
    color: rgb(64, 64, 64);
    font-family: 思源黑体;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0px;
    text-align: center;
    margin-top: 20px;
    margin-bottom: 10px;
  }
  .fuwenben {
    padding-bottom: 50px;
    font-size: 10px;
  }
}
</style>
